export default __webpack_public_path__ + "static/media/plus.53fc5686.svg";